import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import './AddModal.css';

const DeleteFileModal = ({ handleClose, show, rowData, onDelete }) => {
    const [file, setFile] = useState([]);

    useEffect(() => {
        let array = rowData.map((item) => ({
            fileID: item,
            deletedBy: localStorage.getItem('badgeID'),
        }));
        setFile(array);
    }, [rowData]);

    const deleteFile = () => {
        onDelete({
            file,
        });
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title
                    className='delete-modal-title'
                    style={{ color: '#c02d2e', marginBottom: '0px' }}
                >
                    Delete File
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you wish to delete this file?</Modal.Body>
            <Modal.Footer>
                <Button variant='danger' onClick={deleteFile}>
                    Delete File
                </Button>
                <Button variant='outline-secondary' onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteFileModal;
